/**
 * @file Component to assemble other components to construct a view.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractView } from '../../base/helpers/abstract-view';
import { DomainService } from '../../domain.service';
import { DialogService } from '../../core/dialog.service';
import { AlertsService } from '../../core/alerts.service';
import { TranslateService } from '@ngx-translate/core';
/**
 * Class to show entities as data by using the ListComponent
 */
var GridViewComponent = /** @class */ (function (_super) {
    tslib_1.__extends(GridViewComponent, _super);
    /**
     * Constucts a GridViewComponent component.
     * @param configurationsService The configuration service.
     * @param router The router
     * @param route The activated route.
     */
    function GridViewComponent(router, route, dialogService, domainService, alertsService, translateService) {
        var _this = _super.call(this, router, route, domainService, dialogService, alertsService, translateService) || this;
        _this.dialogService = dialogService;
        _this.domainService = domainService;
        _this.alertsService = alertsService;
        // Set configuration to be always defined. Do not use *ngIf because of nested RouterOutlet.
        /** Property where the loaded configuration is divided in logical keys for easy access in the template. */
        _this.configurations = {};
        return _this;
    }
    /**
     * Called when closed event is triggered on sidebar.
     * @param subject The reason of closing the sidebar.
     */
    GridViewComponent.prototype.sidebarIsClosing = function (subject) {
        // if (subject === 'sidebar') {
        //     this.navigateTo(null);
        // }
        // TODO: Implement behavior.
    };
    /**
     * Checks whether the given route is the detail route for the given item.
     * @param detailRoute The route to check.
     * @param item Checks the route for this item.
     * @returns True when detailRoute matches with the given entity otherwise false.
     */
    GridViewComponent.prototype.isDetailRouteForItem = function (detailRoute, item) {
        // Override and use the item parameter in derived classes.
        if (!_super.prototype.isDetailRouteForItem.call(this, detailRoute, item)) {
            return false;
        }
        var itemProp = 'Item';
        var entity = item[itemProp];
        var classProp = 'ItemClass';
        var className = (item[classProp] + '').toLowerCase();
        if (entity) {
            switch (className) {
                // Eerder hielde we rekening met Appointments die geen Absence als reden hadden.
                // Van deze Symagic Server mogelijkheid wordt geen gebruik gemaakt.
                // Appointments behoren nu functioneel altijd een Absence als reden te hebben.
                case 'appointment':
                    className = 'absence';
                    break;
                case 'assignment':
                    if (entity['Appointment']) {
                        // Assignments met waarde true voor de property Appointment worden binnen HTML5 als Appointments gezien.
                        className = 'appointment';
                    }
                    break;
            }
        }
        return detailRoute.path.toLowerCase().indexOf(className) !== -1;
    };
    /**
     * Is called after the block name is set and the configuration is loaded.
     */
    GridViewComponent.prototype.afterInitialize = function () {
        // Improve: use configuration name instead of the component order in the configuration
        this.configurations = {
            insights: this.findChildConfiguration('insights'),
            display: this.findChildComponent('display')
        };
    };
    return GridViewComponent;
}(AbstractView));
export { GridViewComponent };
